import React from 'react'

function isAbsoluteUrl(src: string): boolean {
  return (
    src.startsWith('http://') ||
    src.startsWith('https://') ||
    src.startsWith('//')
  )
}

export type AppImageProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'loading' | 'decoding'
> & {
  src: string
  alt: string
  width?: number
  height?: number
  className?: string
  style?: React.CSSProperties
  /** When provided, relative src is resolved against this base (e.g. API origin). Absolute URLs are never modified. */
  baseUrl?: string
}

const DEFAULT_WIDTH = 300
const DEFAULT_HEIGHT = 300

function AppImage({
  src,
  alt,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  className,
  style,
  baseUrl,
  ...rest
}: AppImageProps) {
  const resolvedSrc = isAbsoluteUrl(src)
    ? src
    : baseUrl
      ? baseUrl.replace(/\/$/, '') + (src.startsWith('/') ? src : '/' + src)
      : src

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      loading="lazy"
      decoding="async"
      width={width}
      height={height}
      className={className}
      style={style}
      {...rest}
    />
  )
}

export default AppImage
